/**
 * created by Jeffery Gao
 * 2018-07-19 09:39:57
 */
import functions from './functions'
import queryAPI from './queryAPI'

export default ({
  queryAPI,
  functions
})



// WEBPACK FOOTER //
// ./src/utils/index.js